<template>
    <div class="form-body">
        <div class="row bottom-space" v-if="isNew">
            <div class="col-md-12">
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" :id="this._uid + 'periodic'" v-model="clonedAppointment.periodic">
                    <label class="custom-control-label float-left" :for="this._uid + 'periodic'">{{ $t("labels.periodic") }}</label>
                </div>
            </div>
        </div>
        <div class="row" v-if="clonedAppointment.periodic">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="periodStart">{{ $t("labels.periodStart") }}</label>
                    <date-picker v-model="clonedAppointment.periodStart" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="periodEnd">{{ $t("labels.periodEnd") }}</label>
                    <date-picker v-model="clonedAppointment.periodEnd" width="100%" format="DD/MM/YYYY" :lang="$i18n.locale"></date-picker>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="periodStep">{{ $t("labels.periodStep") }}</label>
                    <select class="form-control" v-model="clonedAppointment.periodStep">
                        <option value="days">{{ $t("labels.days") }}</option>
                        <option value="weeks">{{ $t("labels.weeks") }}</option>
                        <option value="months">{{ $t("labels.months") }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row" v-if="clonedAppointment.periodStep === 'days' && clonedAppointment.periodic === true">
            <div class="col-md-4">
                <div class="form-group">
                    <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                    <date-picker v-model="clonedAppointment.dailyStart" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm:ss a' : 'HH:mm:ss'" placeholder="Select Time" confirm></date-picker>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                    <date-picker v-model="clonedAppointment.dailyEnd" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm:ss a' : 'HH:mm:ss'" placeholder="Select Time" confirm></date-picker>
                </div>
            </div>
        </div>
        <div class="row" v-if="clonedAppointment.periodStep === 'weeks' && clonedAppointment.periodic === true">
            <div class="col-md-4">
            <div class="form-group">
                    <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                    <date-picker v-model="clonedAppointment.dailyStart" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm:ss a' : 'HH:mm:ss'" placeholder="Select Time" confirm></date-picker>
                </div>
            </div>
            <div class="col-md-4">
            <div class="form-group">
                    <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                    <date-picker v-model="clonedAppointment.dailyEnd" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm:ss a' : 'HH:mm:ss'" placeholder="Select Time" confirm></date-picker>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="dayOfWeek">{{ $t("labels.dayOfWeek") }}</label>
                    <select class="form-control" v-model="clonedAppointment.dayOfWeek">
                        <option value="1">{{ $t("labels.monday") }}</option>
                        <option value="2">{{ $t("labels.tuesday") }}</option>
                        <option value="3">{{ $t("labels.wednesday") }}</option>
                        <option value="4">{{ $t("labels.thursday") }}</option>
                        <option value="5">{{ $t("labels.friday") }}</option>
                        <option value="6">{{ $t("labels.saturday") }}</option>
                        <option value="7">{{ $t("labels.sunday") }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row" v-if="clonedAppointment.periodStep === 'months' && clonedAppointment.periodic === true">
            <div class="col-md-4">
              <div class="form-group">
                  <label for="dailyStart">{{ $t("labels.dailyStart") }}</label>
                  <date-picker v-model="clonedAppointment.dailyStart" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm:ss a' : 'HH:mm:ss'" placeholder="Select Time" confirm></date-picker>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                    <label for="dailyEnd">{{ $t("labels.dailyEnd") }}</label>
                    <date-picker v-model="clonedAppointment.dailyEnd" width="100%" :lang="$i18n.locale" type="time" :format="$i18n.locale === 'en' ? 'hh:mm:ss a' : 'HH:mm:ss'" placeholder="Select Time" confirm></date-picker>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <label for="dayType">{{ $t("labels.dayType") }}</label>
                    <select class="form-control" v-model="clonedAppointment.dayType">
                        <option value="sameday">{{ $t("labels.sameDay") }}</option>
                        <option value="samedayofweek">{{ $t("labels.sameDayOfWeek") }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4" v-if="clonedAppointment.dayType === 'sameday'">
                <div class="form-group">
                    <label for="dayOfMonth">{{ $t("labels.dayOfMonth") }}</label>
                    <input type="number" class="form-control" v-model="clonedAppointment.dayOfMonth">
                </div>
            </div>
            <div class="col-md-4" v-if="clonedAppointment.dayType === 'samedayofweek'">
                <div class="form-group">
                    <label for="weekOfMonth">{{ $t("labels.weekOfMonth") }}</label>
                    <select class="form-control" v-model="clonedAppointment.weekOfMonth">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4" v-if="clonedAppointment.dayType === 'samedayofweek'">
                    <div class="form-group">
                    <label for="dayOfWeek">{{ $t("labels.dayOfWeek") }}</label>
                    <select class="form-control" v-model="clonedAppointment.dayOfWeek">
                        <option value="1">{{ $t("labels.monday") }}</option>
                        <option value="2">{{ $t("labels.tuesday") }}</option>
                        <option value="3">{{ $t("labels.wednesday") }}</option>
                        <option value="4">{{ $t("labels.thursday") }}</option>
                        <option value="5">{{ $t("labels.friday") }}</option>
                        <option value="6">{{ $t("labels.saturday") }}</option>
                        <option value="7">{{ $t("labels.sunday") }}</option>
                    </select>
                </div>
            </div>
            
        </div>
        <div class="row">
            <div class="col-md-4" v-if="!clonedAppointment.periodic">
                <div class="form-group">
                    <label for="date"><span class="required">*</span>{{ $t("labels.startDate") }}</label>
                    <date-picker v-model="clonedAppointment.startDate" :lang="$i18n.locale" width="100%" type="datetime" :popupStyle="{top: 30, left: 0}" :format="$i18n.locale === 'en' ? 'DD/MM/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm'" :minute-step="1" confirm></date-picker>
                </div>
            </div>
             <div class="col-md-4" v-if="!clonedAppointment.periodic">
                <div class="form-group">
                    <label for="date">{{ $t("labels.endDate") }}</label>
                    <date-picker v-model="clonedAppointment.endDate" :lang="$i18n.locale" width="100%" type="datetime" :popupStyle="{top: 30, left: 0}" :format="$i18n.locale === 'en' ? 'DD/MM/YYYY hh:mm a' : 'DD/MM/YYYY HH:mm'" :minute-step="1" confirm></date-picker>
                </div>
            </div>
        </div>
        <div class="row">
             <div class="col-md-12">
                <div class="form-group">
                    <label for="location"><span class="required">*</span>{{ $t("labels.location") }}</label>
                    <input type="text" class="form-control" v-model="clonedAppointment.location">
                </div>
            </div>
        </div>
         <div class="row bottom-space">
            <div class="col-md-12">
                <label for="description"><span class="required">*</span>{{ $t("labels.description") }}</label>
                <textarea id="description" class="form-control" v-model="clonedAppointment.description"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                 <div class="form-group">
                    <label for="notifyBy">{{ $t("labels.notifyBy") }}</label>
                    <select class="form-control" v-model="clonedAppointment.notifyBy">
                        <option value="email" selected>{{ $t("labels.notifyByEmail") }}</option>
                        <option value="app" selected>{{ $t("labels.notifyByApp") }}</option>
                    </select>
                </div>
            </div>
            <div class="col-md-6">
                 <div class="form-group">
                    <label for="notifyWhen">{{ $t("labels.notifyWhen") }}</label>
                    <select class="form-control" v-model="clonedAppointment.notifyWhen">
                        <option value="1 hour before" selected>{{ $t("labels.oneHour") }}</option>
                        <option value="3 hours before" selected>{{ $t("labels.threeHours") }}</option>
                        <option value="1 day before" selected>{{ $t("labels.oneDay") }}</option>
                        <option value="2 days before" selected>{{ $t("labels.twoDays") }}</option>
                    </select>
                </div>
            </div>
        </div>
       
    </div>
</template>

<script>
import moment from 'moment'

export default {
    props: {
      isNew: {
        type: Boolean,
        default: true,
      },
      appointment: {
        type: Object,
        default: () => {}
      }
    },
    data(){
        return {
            date: null,
            hour: null,
            types: ['health_state', 'event'],
            clonedAppointment: {}
        }
    },
    methods: {
      changePeriodicValue:  function(event) {
        console.log('changePeriodicValue -->', this.clonedAppointment.periodic) 
        if (this.clonedAppointment) {
          this.clonedAppointment = Object.assign({}, this.clonedAppointment, { periodic: !this.clonedAppointment.periodic})
        }else {
          this.clonedAppointment = Object.assign({}, this.clonedAppointment, { periodic: true })
        }
      },
      translatedAppointmentType: function(eventType){      
        return this.$t(`lovTypes.${eventType}`)
      },
      fullDate() {
          let date = this.date + ' ' + this.hour
          this.appointment.date = new Date(date)
      },
      timeFormat(d) {
          return moment(d).format('hh:mm:ss a')
      }
    },
    mounted() {
    },
    watch: {
      'appointment':  {
        handler: function(newValue) {
          this.clonedAppointment = Object.assign({}, newValue)
        },
        deep: true
      },
      'clonedAppointment.periodic': function(newValue) {
        if (newValue) {
          this.clonedAppointment = Object.assign({}, this.clonedAppointment, {
            periodStart: moment(this.clonedAppointment.startDate), 
            periodEnd: moment(this.thisclonedAppointment.endDate),
            dailyStart: moment(this.clonedAppointment.startDate), 
            dailyEnd: moment(this.clonedAppointment.endDate),
          })
        }else {
          this.clonedAppointment = Object.assign({}, this.clonedAppointment, { 
            startDate: moment(moment(this.clonedAppointment.periodStart).format('YYYY-MM-DD') + ' ' + moment(this.clonedAppointment.dailyStart).format('HH:mm')), 
            endDate: moment(moment(this.clonedAppointment.periodEnd).format('YYYY-MM-DD') + ' ' + moment(this.clonedAppointment.dailyEnd).format('HH:mm')),
          })
        }
      }
    }
}
</script>